import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "align-middle" }

import { computed } from "vue";
import MaterialIcon from "@/shared/components/utils/MaterialIcon.vue";

interface PropsInterface {
  color: string;
  icon?: string;
  outline?: boolean;
  pill?: boolean;
  soft?: boolean;
  margeEnd?: boolean;
  margeStart?: boolean;
  canBeDeleted?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleBadge',
  props: {
    color: null,
    icon: null,
    outline: { type: Boolean },
    pill: { type: Boolean },
    soft: { type: Boolean },
    margeEnd: { type: Boolean },
    margeStart: { type: Boolean },
    canBeDeleted: { type: Boolean }
  },
  emits: ["delete"],
  setup(__props: any, { emit }: { emit: ({
  (e: "delete"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  color: string;
  icon?: string;
  outline?: boolean;
  pill?: boolean;
  soft?: boolean;
  margeEnd?: boolean;
  margeStart?: boolean;
  canBeDeleted?: boolean;
};


const clss = computed(() => {
  const result = ["badge"];
  if (props.outline) {
    result.push("badge-outline", `text-${props.color}`);
  } else {
    if (props.soft) {
      result.push(`bg-${props.color}-lt`);
    } else {
      result.push(`bg-${props.color}`);
    }
  }
  if (props.pill) {
    result.push("badge-pill");
  }
  if (props.margeStart) {
    result.push("ms-1");
  }
  if (props.margeEnd) {
    result.push("me-1");
  }
  return result;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_unref(clss))
  }, [
    (props.icon)
      ? (_openBlock(), _createBlock(MaterialIcon, {
          key: 0,
          class: "me-1 align-middle",
          style: {"font-size":"unset"},
          name: props.icon
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (props.canBeDeleted)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          role: "button",
          class: "text-muted align-middle",
          "aria-hidden": "true",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('delete')))
        }, " × "))
      : _createCommentVNode("", true)
  ], 2))
}
}

})